
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { LandingLayout } from '@/components/layouts/LandingLayout';
import { TranslationProvider } from '@/context/translation';
import { createNonLocalizedPageGetServerSidePropsWithTranslations, type NonLocalizedPageWithTranslationsProps, } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const GraphicsLanding = dynamic(async () => await import('@/templates/Landing/Graphics/GraphicsLanding'), {
    loading: LoaderScreen,
});
const index: React.FC<NonLocalizedPageWithTranslationsProps> = ({ locale, translations, }) => {
    return (<TranslationProvider locale={locale} translations={translations}>
			<LandingLayout title='Create Stunning Branded Social Media Graphics in Seconds | Lift ' description='Lift helps you create professional, on-brand social media graphics instantly with AI-powered templates and tools. Design for Instagram, TikTok, Facebook, and more — no design skills needed.' ogTitle='AI-Powered Social Media Graphics for Your Brand | Lift' ogDescription='Stand out online with branded social media visuals. Use Lift’s AI tools to design scroll-stopping content for Instagram, TikTok, LinkedIn, and more — in just a few clicks.'>
				<GraphicsLanding />
			</LandingLayout>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createNonLocalizedPageGetServerSidePropsWithTranslations('/for-businesses/branded-sm-graphics', 'branded-sm-graphics');

    async function __Next_Translate__getServerSideProps__1a1a20bb8a7__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/for-businesses/branded-sm-graphics/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb8a7__ as getServerSideProps }
  